exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".appraiser{font-family:Source Sans Pro,sans-serif}", ""]);

